import React from "react"
export function TravelsafeIconMono(props) {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <g
        id="prefix__TS-Icon-Monochrome"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="prefix__TS">
          <path
            d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm5.683 6.587a.988.988 0 00-1.35.027L13.45 9.48 8.315 7.738a.353.353 0 00-.355.077L6.83 8.892l4.542 2.655-2.833 2.817-.98-.374a.353.353 0 00-.367.072l-.859.818 1.989 1.223L9.605 18l.858-.819.038-.042a.313.313 0 00.038-.309l-.509-1.208 2.723-2.708 2.7 4.202 1.13-1.078.042-.048a.313.313 0 00.039-.29l-1.816-4.87 2.863-2.846a.957.957 0 000-1.37z"
            id="prefix__Combined-Shape"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  )
}
